var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCohortInstitutionIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 5.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 5.5,
    stroke: "#BBC3F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66669 15.9993V13.3813C9.66669 12.9788 9.95444 12.6338 10.3505 12.5615L17.8505 11.1932C17.9494 11.1752 18.0507 11.1752 18.1496 11.1932L25.6495 12.5615C26.0455 12.6338 26.3334 12.9788 26.3334 13.3813V15.9993C26.3334 16.4595 25.9602 16.8326 25.5 16.8326H10.5C10.0398 16.8326 9.66669 16.4595 9.66669 15.9993Z",
    fill: "#4B5ED2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 25.4359V16.832H25.3333V25.4359C25.3333 25.9307 24.9601 26.332 24.5 26.332H11.6666C11.2064 26.332 10.8333 25.9307 10.8333 25.4359Z",
    fill: "#6C7DE5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9993 13.8346C13.9993 16.1358 15.8648 18.0013 18.166 18.0013C20.4672 18.0013 22.3327 16.1358 22.3327 13.8346C22.3327 11.5335 20.4672 9.66797 18.166 9.66797C15.8648 9.66797 13.9993 11.5335 13.9993 13.8346Z",
    fill: "#5FEDD3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.606 13.303C18.606 13.1357 18.4704 13 18.303 13C18.1356 13 18 13.1357 18 13.303V13.6061H17.4124C17.0688 13.6061 16.7902 13.7414 16.6014 13.9591C16.4179 14.1707 16.3333 14.4431 16.3333 14.7045C16.3333 14.966 16.4179 15.2383 16.6014 15.45C16.7902 15.6677 17.0688 15.803 17.4124 15.803H18V16.7879H16.8597C16.6923 16.7879 16.5566 16.9235 16.5566 17.0909C16.5566 17.2583 16.6923 17.3939 16.8597 17.3939H18V17.697C18 17.8643 18.1356 18 18.303 18C18.4704 18 18.606 17.8643 18.606 17.697V17.3939H19.1936C19.5372 17.3939 19.8158 17.2586 20.0046 17.0409C20.1881 16.8293 20.2727 16.5569 20.2727 16.2955C20.2727 16.034 20.1881 15.7617 20.0046 15.55C19.8158 15.3323 19.5372 15.197 19.1936 15.197H18.606V14.2121H19.6371C19.8044 14.2121 19.9401 14.0765 19.9401 13.9091C19.9401 13.7417 19.8044 13.6061 19.6371 13.6061H18.606V13.303ZM18 14.2121H17.4124C17.2386 14.2121 17.1292 14.2756 17.0593 14.3562C16.9841 14.4429 16.9394 14.5683 16.9394 14.7045C16.9394 14.8408 16.9841 14.9662 17.0593 15.0529C17.1292 15.1335 17.2386 15.197 17.4124 15.197H18V14.2121ZM18.606 15.803V16.7879H19.1936C19.3674 16.7879 19.4769 16.7244 19.5467 16.6438C19.6219 16.5571 19.6666 16.4317 19.6666 16.2955C19.6666 16.1592 19.6219 16.0338 19.5467 15.9471C19.4769 15.8665 19.3674 15.803 19.1936 15.803H18.606Z",
    fill: "#4B5ED2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 25.5V22.3333C14.5 21.8731 14.8731 21.5 15.3333 21.5H20.6667C21.1269 21.5 21.5 21.8731 21.5 22.3333V26.3333H15.3333C14.8731 26.3333 14.5 25.9602 14.5 25.5Z",
    fill: "#D8DEFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 22.3333C14.5 21.8731 14.8918 21.5 15.375 21.5H18V26.3333H14.5C14.5 25 14.5 23.6667 14.5 22.3333Z",
    fill: "#D8DEFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCohortInstitutionIcon);
export default __webpack_public_path__ + "static/media/cohort-institution-icon.7c542fe18359747b652f875b674dd816.svg";
export { ForwardRef as ReactComponent };